/* ajax-cart.js — Adds any `form[data-ajax-cart]` to the cart via AJAX and
   opens the slide-out cart drawer, instead of navigating to the /cart page.

   - Event-delegated on document, so it survives Section Rendering API swaps
     (Series/Model picker re-renders the test PDP) without re-binding.
   - Idempotent: guarded so it binds at most once even if loaded by several
     sections on the same page.
   - Theme-native: `cart:refresh` refreshes the drawer contents + header
     cart count exactly like the theme's own <product-form>; the drawer's
     own show() method opens it. */
(function () {
  if (window.__ajaxCartBound) return;
  window.__ajaxCartBound = true;

  function openDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.show === 'function') drawer.show();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || typeof form.matches !== 'function' ||
        !form.matches('form[data-ajax-cart]')) return;

    event.preventDefault();

    /* Buttons to show busy / "Try Again" state on: in-form submit buttons,
       plus the actual submitter — which may be an external button associated
       via the `form` attribute (e.g. the test PDP's sticky buy card). */
    var buttons = Array.prototype.slice.call(
      form.querySelectorAll('button[type="submit"]')
    );
    if (event.submitter && buttons.indexOf(event.submitter) === -1) {
      buttons.push(event.submitter);
    }
    buttons.forEach(function (b) { b.disabled = true; });

    /* Normalise the variant id: the custom PDP forms carry both a hidden
       `id` input and a checked variant radio (also name="id"). Collapse to
       the single selected value so /cart/add gets one unambiguous id. */
    var body = new FormData(form);
    var picked = form.querySelector('input[name="id"]:checked') ||
                 form.querySelector('input[name="id"]');
    if (picked) body.set('id', picked.value);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: body
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error((data && data.description) || 'Could not add to cart.');
          }
          return data;
        });
      })
      .then(function () {
        /* Refresh the drawer contents + header cart count, then open it. */
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        openDrawer();
        buttons.forEach(function (b) { b.disabled = false; });
      })
      .catch(function (error) {
        buttons.forEach(function (b) {
          b.disabled = false;
          if (b.dataset.ajaxCartLabel === undefined) {
            b.dataset.ajaxCartLabel = b.textContent;
          }
          b.textContent = 'Try Again';
          setTimeout(function () { b.textContent = b.dataset.ajaxCartLabel; }, 2500);
        });
        if (window.console) console.warn('[ajax-cart]', error);
      });
  }, false);
})();
